module.exports = __webpack_public_path__ + "static/images/broken-link.85b86d423880de449b607c1ae5ebdd50.svg";